export const OPEN_ADMIN_MENU = '@admin/OPEN_ADMIN_MENU'
export const CLOSE_ADMIN_MENU = '@admin/CLOSE_ADMIN_MENU'
